var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostgresqlIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 518.7 530.5",
    style: {
      enableBackground: "new 0 0 518.7 530.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill:none;stroke:#fff;stroke-width:12.4651;stroke-linecap:round;stroke-linejoin:round}")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.6 388c3.4-28.5 2.4-32.7 23.6-28.1l5.4.5c16.3.7 37.7-2.6 50.3-8.5 27-12.5 43.1-33.5 16.4-28-60.8 12.5-65-8-65-8 64.2-95.2 91-216.1 67.9-245.7C426-10.5 316.7 27.6 314.8 28.6l-.6.1c-12-2.5-25.5-4-40.6-4.2-27.5-.5-48.4 7.2-64.2 19.2 0 0-195.1-80.4-186 101.1 1.9 38.6 55.3 292.1 119 215.5 23.3-28 45.8-51.7 45.8-51.7 11.2 7.4 24.5 11.2 38.6 9.8l1.1-.9c-.3 3.5-.2 6.9.4 10.9-16.3 18.3-11.5 21.6-44.3 28.3-33.2 6.8-13.7 19-1 22.2 15.4 3.9 51.1 9.3 75.3-24.4l-1 3.9c6.4 5.1 6 37 6.9 59.8.9 22.8 2.4 44 7.1 56.5 4.6 12.5 10.1 44.8 53.2 35.5 36.1-7.8 63.6-18.9 66.1-122.2",
    style: {
      stroke: "#000",
      strokeWidth: 37.3953
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.3 323.9c-60.8 12.5-65-8-65-8 64.2-95.2 91-216.2 67.9-245.7C426-10.5 316.7 27.7 314.8 28.6l-.6.1c-12-2.5-25.5-4-40.6-4.2-27.5-.5-48.4 7.2-64.2 19.2 0 0-195.1-80.4-186 101.1 1.9 38.6 55.3 292.1 119 215.5 23.3-28 45.8-51.7 45.8-51.7 11.2 7.4 24.5 11.2 38.6 9.8l1.1-.9c-.3 3.5-.2 6.9.4 10.9-16.3 18.3-11.5 21.6-44.3 28.3-33.2 6.8-13.7 19-1 22.2 15.4 3.9 51.1 9.3 75.3-24.4l-1 3.9c6.4 5.1 10.9 33.5 10.2 59.2-.8 25.7-1.3 43.3 3.8 57.1 5.1 13.8 10.1 44.8 53.2 35.5 36-7.7 54.7-27.7 57.3-61.1 1.8-23.7 6-20.2 6.3-41.4l3.3-10c3.9-32.2.6-42.5 22.8-37.7l5.4.5c16.3.7 37.7-2.6 50.3-8.5 27.1-12.7 43.1-33.6 16.4-28.1z",
    style: {
      fill: "#336791"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M260.9 342.3c-1.7 59.8.4 120.1 6.3 134.8 5.9 14.6 18.4 43.1 61.5 33.9 36-7.7 49.1-22.7 54.8-55.7 4.2-24.3 12.3-91.7 13.3-105.5M209.2 42.3S14-37.5 23.1 144c1.9 38.6 55.3 292.1 119 215.5 23.3-28 44.3-50 44.3-50M314.7 27.8c-6.8 2.1 108.6-42.2 174.1 41.6 23.2 29.6-3.7 150.5-67.9 245.7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M420.9 315.1s4.2 20.6 65 8c26.6-5.5 10.6 15.4-16.4 28-22.2 10.3-71.9 12.9-72.7-1.3-2.1-36.6 26.2-25.5 24.1-34.7-1.8-8.3-14.5-16.4-22.8-36.7-7.3-17.7-100.1-153.3 25.7-133.2 4.6-1-32.8-119.7-150.5-121.6-117.7-1.9-113.8 144.7-113.8 144.7",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 12.4651,
      strokeLinecap: "round",
      strokeLinejoin: "bevel"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M227.9 327.7c-16.4 18.3-11.6 21.5-44.4 28.3-33.2 6.8-13.7 19-1 22.2 15.4 3.9 51.1 9.3 75.3-24.4 7.3-10.3 0-26.7-10.1-30.9-4.9-2.1-11.4-4.6-19.8 4.8h0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M226.9 327.3c-1.7-10.8 3.5-23.6 9.1-38.6 8.4-22.5 27.7-45 12.2-116.4-11.5-53.2-88.7-11.1-88.8-3.9 0 7.2 3.5 36.6-1.3 70.8-6.2 44.6 28.4 82.3 68.3 78.5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.5 167.4c-.3 2.5 4.5 9 10.8 9.9 6.3.9 11.7-4.3 12.1-6.7.3-2.5-4.5-5.2-10.8-6.1-6.3-.9-11.8.4-12.1 2.9z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 4.155
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.2 162.3c.3 2.5-4.5 9-10.8 9.9-6.3.9-11.7-4.3-12.1-6.7-.3-2.5 4.5-5.2 10.9-6.1 6.2-.8 11.6.5 12 2.9z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 2.0775
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M423.8 145.3c1 19.3-4.2 32.5-4.8 53.1-1 29.9 14.3 64.1-8.7 98.4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostgresqlIcon);
export default __webpack_public_path__ + "static/media/postgresql-icon.6548612890e81f6ed7b0d637fa386960.svg";
export { ForwardRef as ReactComponent };